module.exports = "https://dev.stanwinstonschool.com/OA-logo.d1199f48ec75860fd398388f48e15bc8.png";